import { Injectable } from '@angular/core';
import { CookieService } from 'ngx-cookie-service';
import { CriptoService } from './cripto.service';

@Injectable({
  providedIn: 'root'
})
export class SecureCookiesService  {
  private readonly encryptionPassword = 'your-strong-password'; // Deberías obtener esto de forma segura

  constructor(
    private cookieService: CookieService,
    private cryptoService: CriptoService
  ) { }

  // Establecer cookie encriptada
  async setEncryptedCookie(
    name: string,
    value: string,
    expires?: number | Date,
    path?: string,
    domain?: string,
    secure?: boolean,
    sameSite?: 'Lax' | 'Strict' | 'None'
  ): Promise<void> {
    const encryptedValue = await this.cryptoService.encrypt(value, this.encryptionPassword);
    this.cookieService.set(name, encryptedValue, expires, path, domain, secure, sameSite);
  }

  // Obtener cookie desencriptada
  async getDecryptedCookie(name: string){
    const encryptedValue = this.cookieService.get(name);
    if (!encryptedValue) return undefined;
    
    return await this.cryptoService.decrypt(encryptedValue, this.encryptionPassword);
  }

  // Eliminar cookie
  deleteCookie(name: string, path?: string, domain?: string) {
    this.cookieService.delete(name, path, domain);
  }
}
